import React from 'react'
import PropTypes, { bool } from 'prop-types'
import { STYLES } from './utils'
import Carousel from './Carousel'
import Grid from './Grid'

const RowV3 = (props) => {
  const {
    style,
    className,
    asGrid,
  } = props

  const rowClassName = [
    'row-v2 row-v2--disable-scale',
    style ? `row-v2--${style}` : null,
    className ? `row-v2--${className}` : null,
    asGrid ? 'row-v2--grid' : null,
  ].filter((cls) => !!cls).join(' ')

  return (
    <div className={rowClassName}>
      {asGrid
        ? <Grid {...props} />
        : <Carousel {...props} />
      }
    </div>
  )
}

RowV3.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.oneOf([
    STYLES.DEFAULT,
    STYLES.S12345,
    STYLES.S12334,
    STYLES.S12234,
    STYLES.S23456,
    STYLES.SINGLE,
    STYLES.TILES_VERTICAL,
    STYLES.TILES_GAIA_PLUS,
    STYLES.TILES_TOP_TEN,
  ]),
  asGrid: bool,
}

RowV3.defaultProps = {
  style: STYLES.S12345,
  asGrid: false,
}

export default RowV3
